<template>
  <o-scroll class="bg-white max-h-xs dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl shadow-lg flex flex-col gap-0.5 overflow-auto p-1.5 relative">
    <template v-if="items.length">
      <button
        v-for="(item, index) in items"
        :key="index"
        :class="[
          'flex items-center gap-1 bg-transparent text-left w-full px-2 py-1 rounded transition-colors',
          index === selectedIndex ? 'bg-gray-100 dark:bg-gray-800/50' : '',
          'hover:bg-gray-100 dark:hover:bg-gray-800/50'
        ]"
        @click="selectItem(index)"
      >
        {{ item.label || item.id || item }}
      </button>
    </template>
    <div v-else class="px-2 py-1">
      {{ $t('components.elements.editor.mentionList.noResult') }}
    </div>
  </o-scroll>
</template>

<script setup lang="ts">
interface Props {
  items: any[]
  command: Function
}

const props = defineProps<Props>()

const selectedIndex = ref(0)

watch(() => props.items, () => {
  selectedIndex.value = 0
})

function onKeyDown ({ event }: { event: KeyboardEvent }) {
  if (event.key === 'ArrowUp') {
    upHandler()
    return true
  }

  if (event.key === 'ArrowDown') {
    downHandler()
    return true
  }

  if (event.key === 'Enter') {
    enterHandler()
    return true
  }

  return false
}

function upHandler () {
  selectedIndex.value = ((selectedIndex.value + props.items.length) - 1) % props.items.length
}

function downHandler () {
  selectedIndex.value = (selectedIndex.value + 1) % props.items.length
}

function enterHandler () {
  selectItem(selectedIndex.value)
}

function selectItem (index: number) {
  const item = props.items[index]

  if (item) {
    props.command(item)
  }
}

defineExpose({ onKeyDown })
</script>
